<script lang="ts">
		import type { BasicContent } from '$lib/domain/basic-content.interface';

		export let faq: BasicContent[];

		let expandedItemIndex: number | null = 0;

		let handleClick = (i: number) => (expandedItemIndex = expandedItemIndex === i ? null : i);
</script>

<div class="faq-accordeon flex-column">
	{#each faq as faqItem, i}
		<article
			on:click="{() => handleClick(i)}"
			on:keydown="{() => handleClick(i)}"
			class:active="{expandedItemIndex === i}">
			<div class="left-column">
				<div class="faq-collapse">-</div>
				<div class="faq-expand">+</div>
			</div>
			
			<div class="content-wrapper flex-column">
				<h3>{@html faqItem.title}</h3>
				<p>{@html faqItem.content}</p>
			</div>
		</article>
	{/each}
</div>

<style lang="scss">
  @import '$styles/vars';

  .faq-accordeon {
		width: 100%;
		display: flex;
		row-gap: 12px;
	
		article {
			background-color: $light-grey;
			border-radius: 12px;
			padding: 24px;
			display: flex;
			flex-direction: row;
			align-items: flex-start;
			column-gap: 24px;
			cursor: pointer;
			transition: 0.5s all;
	
			&:hover {
			filter: brightness(90%);
			}
	
			&.active {
			max-height: fit-content;
	
			.left-column {
				.faq-collapse {
				display: flex;
				}
	
				.faq-expand {
				display: none;
				}
			}
	
			.content-wrapper {
				p {
				-webkit-transition: max-height 500ms;
				-moz-transition: max-height 500ms;
				-ms-transition: max-height 500ms;
				-o-transition: max-height 500ms;
				transition: max-height 500ms;
				transition-timing-function: ease;
				max-height: 600px;
				margin-top: 12px;
				}
			}
			}
	
			.left-column {
			.faq-collapse,
			.faq-expand {
				color: $green;
				font-size: 24px;
				font-weight: 800;
			}
	
			.faq-expand {
				display: flex;
			}
	
			.faq-collapse {
				display: none;
			}
			}
	
			.content-wrapper {
			h3 {
				font-size: 24px;
				line-height: 36px;
				text-align: start;
			}
	
			p {
				max-height: 0;
				overflow: hidden;
				-webkit-transition: max-height 200ms;
				-moz-transition: max-height 200ms;
				-ms-transition: max-height 200ms;
				-o-transition: max-height 200ms;
				transition: max-height 200ms;
				transition-timing-function: ease;
				margin: 0;
			}
			}
		}
  }

  @media (max-width: $portrait-phone-size) {
		.faq-accordeon {
			article {
			padding: 16px;
			}
		}
  }
</style>
